import { SBox, SIcon } from '@avalara/skylab-sdk/react';
import { useSelector } from 'react-redux';

import { selectState } from '../../../selectors';

const integrationDetails = [
  'Connect seamlessly to AvaTax for up-to-date sales tax calculation',
  'Send tax calculations to your sales applications and pull sales order data for returns filing',
  'Free with your AvaTax subscription',
];

const IntegrationDetailsPanel = () => {
  const {
    account: { connector },
  } = useSelector(selectState);
  return (
    <SBox className='secondary pad-all-md'>
      <h1 className='pad-bottom-md'>{`Add ${connector.name} to your account`}</h1>

      {integrationDetails.map((step) => (
        <p className='margin-bottom-sm' key={`nextstep${step}`}>
          <SIcon name='check' className='margin-right-sm' />
          <span className='text-md'>{step}</span>
        </p>
      ))}
    </SBox>
  );
};

export default IntegrationDetailsPanel;
